import NextErrorPage from 'next/error'

/**
 *
 */
export default function NotFound() {
  return (
    <>
      <NextErrorPage statusCode={404} />
    </>
  )
}
